<template>
  <div v-if="isOpen">
    <div class="modal-mobile-app" @click="closeModal">
      <div class="modal-mobile-app-body">
        <div class="modal-mobile-app-inner" @click.stop="">
          <!-- Image with transparent background -->
          <div class="modal-image-wrapper">
            <img :src="mobileAppImage" alt="" class="mobile-app-image"/>

            <!-- Invisible clickable areas -->
            <div class="clickable-area close-area" @click="closeModal"></div>
            <div class="clickable-area app-store-area" @click="onClickAppStore"></div>
            <div class="clickable-area play-store-area" @click="onClickPlayStore"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import externalSites from "@/constants/externalSites"
import { gtmTrackEvent } from "@/helpers/gtm"
import { GTM_EVENT_NAMES } from "@/constants/gtm"

export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    mobileAppImage() {
      const locale = this.$i18n.locale;
      if (locale === 'id') {
        return require('@/assets/img/bond-listing/bond_listing_mobile_only_id.png');
      }
      return require('@/assets/img/bond-listing/bond_listing_mobile_only_en.png');
    }
  },
  methods: {
    closeModal() {
      this.$emit('update:isOpen', false);
    },
    onClickAppStore() {
      gtmTrackEvent({
        event: GTM_EVENT_NAMES.APP_STORE_BUTTON
      });
      window.open(externalSites.STORE.APP_STORE, '_blank');
    },
    onClickPlayStore() {
      gtmTrackEvent({
        event: GTM_EVENT_NAMES.PLAY_STORE_BUTTON
      });
      window.open(externalSites.STORE.GOOGLE_PLAY, '_blank');
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-mobile-app {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;

  .modal-mobile-app-body {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;

    .modal-mobile-app-inner {
      position: relative;
      max-width: 800px;
      max-height: 90vh;
      cursor: default;

      .modal-image-wrapper {
        position: relative;
        width: 100%;
        height: 100%;

        .mobile-app-image {
          width: 100%;
          height: auto;
          display: block;
          max-height: 90vh;
          object-fit: contain;
        }

        .clickable-area {
          position: absolute;
          cursor: pointer;
          transition: opacity 0.2s;

          &:hover {
            opacity: 0.1;
            background-color: rgba(255, 255, 255, 0.1);
          }
        }

        .close-area {
          top: 2.5%;
          right: 2.5%;
          width: 8%;
          height: 8%;
        }

        .app-store-area {
          bottom: 29%;
          right: 24.5%;
          width: 14%;
          height: 8%;
        }

        .play-store-area {
          bottom: 29%;
          right: 10%;
          width: 14%;
          height: 8%;
        }
      }
    }
  }
}
</style>

